"use client";

import { useMutation } from "@tanstack/react-query";
import { browserCmw } from "@/lib/ky/browser";

// No hook-level `onError`: the component reads the error body itself (fieldError vs general
// error), and a body can only be read once — see .spec/context/gotchas.md §3.
export const useRequestSignInCode = () =>
  useMutation({
    mutationFn: (email: string) => browserCmw.auth.requestSignInCode({ email }),
  });
